module.exports = __webpack_public_path__ + "img/base_activites_atelier.18c10e16.svg";